import { SVGProps, Ref, forwardRef } from 'react';

export const ZarplataSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11M6.687 14.935v1.879a.57.57 0 0 0 .352.522c1.207.517 2.686.784 4.474.784 1.84 0 3.333-.372 4.452-1.12q1.716-1.155 1.716-2.91c0-1.463-.867-2.427-2.036-2.872-.08-.031-.083-.147-.005-.18 1.029-.436 1.543-1.298 1.543-2.568 0-.97-.522-1.792-1.541-2.438q-1.53-.97-3.806-.97c-1.738 0-3.23.246-4.44.738a.57.57 0 0 0-.36.527v1.792a.373.373 0 0 0 .509.349c1.045-.418 2.22-.62 3.52-.62q2.537 0 2.537 1.194c0 .722-.597 1.094-1.79 1.094H9.753a.38.38 0 0 0-.38.38v1.778a.38.38 0 0 0 .38.38h2.057c1.468 0 2.189.397 2.189 1.219 0 .92-1.095 1.442-2.985 1.442-1.38 0-2.648-.244-3.804-.746a.376.376 0 0 0-.524.346"
            fill="currentColor"
        />
    </svg>
));
ZarplataSolidSize24Glyph.displayName = 'ZarplataSolidSize24Glyph';
